import classNames from "classnames";
import { ChipTemplate } from "../Template";
import styles from "./ChipStatus.module.scss";
import React from "react";
function ChipStatus({ size, styleType, className, classNameContent, classNamesStateLayer, iconOnly, ...props }) {
    return (React.createElement(ChipTemplate, { className: classNames(styles["chip-status"], styles[`size-${size}`], styles[styleType], iconOnly && styles["icon-only"], className), classNameContent: classNames(styles.content, classNameContent), classNamesStateLayer: classNames(styles["state-layer"], classNamesStateLayer), ...props }));
}
export default ChipStatus;
